const Preferences = require('./Preferences');
const { getEventTracker } = require('../../../utils/event-tracker');

const CodeSnippetsParser = () => {
  const Tracker = getEventTracker();

  function changeActive(container, language) {
    for (let i = 0; i < container.length; i += 1) {
      let languageExists = false;
      const elementContainer = container[i].children;

      if (language) {
        // Check if the language exists on the container
        for (let j = 0; j < elementContainer.length; j += 1) {
          const panel = elementContainer[j];

          if (language === panel?.children[0]?.getAttribute('language-type')) {
            languageExists = true;
          }
        }
      }
      // Select the first is the language isnt saved or the language doesnt exists on the container
      if (language && languageExists) {
        for (let j = 0; j < elementContainer.length; j += 1) {
          const panel = elementContainer[j];

          if (language === panel?.children[0]?.getAttribute('language-type')) {
            panel.classList.add('active');
          } else {
            panel.classList.remove('active');
          }
        }
      } else {
        for (let j = 0; j < elementContainer.length; j += 1) {
          const panel = elementContainer[j];
          panel.classList.remove('active');
        }
        const firstElement = container[i].children[0];
        firstElement.classList.add('active');
      }
    }
  }

  function setLanguage(languageToChange) {
    const languageSelected = languageToChange || Preferences.getLanguage();
    const codeContainers = document.getElementsByClassName('tab-content');
    const tabsContainer = document.getElementsByClassName('nav-tabs');

    changeActive(codeContainers, languageSelected);
    changeActive(tabsContainer, languageSelected);
  }
  function attachLangPreferences() {
    const tabCodeSelectors = document.getElementsByClassName('code_tab_selector');

    for (let i = 0; i < tabCodeSelectors.length; i += 1) {
      const tab = tabCodeSelectors[i];
      const language = tab.getAttribute('language-type');

      tab.addEventListener('click', () => {
        Preferences.setLanguage(language);
        // Change active languages in all containers
        setLanguage(language);
      }, false);
    }
  }

  function setCopyCode() {
    const copyButtons = document.getElementsByClassName('btn-copy-code');
    const langMatch = window.location.pathname.match(/\/developers\/(pt|en|es)/);
    const pageLang = langMatch ? langMatch[1] : 'es';
    for (let i = 0; i < copyButtons.length; i += 1) {
      const copyButton = copyButtons[i];

      copyButton.addEventListener('click', (event) => {
        const snippetId = event.srcElement.getAttribute('data-snippet-id');
        const codeText = document.getElementById(`code_${snippetId}`)?.textContent;
        navigator.clipboard.writeText(codeText).then(() => {
          event.srcElement.textContent = pageLang === 'en' ? 'Copied' : 'Copiado';
          setTimeout(() => {
            event.srcElement.textContent = pageLang === 'en' ? 'Copy' : 'Copiar';
          }, 2000);
        }).catch(err => {
          console.error('Failed to copy text: ', err);
        });

        const language = document.getElementById(`code_${snippetId}`)?.classList[0].split('-')[1];
        Tracker.send(`mpdevelopers/snippet_copied_${language}`);
      });
    }
  }

  setLanguage();
  attachLangPreferences();
  setCopyCode();
};

module.exports = CodeSnippetsParser;
